import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';

@Component({
  selector: 'app-shipment-title',
  templateUrl: './shipment-title.component.html',
  styleUrls: ['./shipment-title.component.scss']
})
export class ShipmentTitleComponent implements OnChanges {
  @Input() order: any;
  @Input() shipment: any;
  @Input() showCircle = true;
  prepare = false;
  pageSize = 3;
  rows = [
    {label: 'Consignment no', value: 'consignment_no'},
    {label: 'Consignor', value: 'consignor'},
    {label: 'Consignee', value: 'consignee'},
    {label: 'Status', value: 'status'},
    {label: 'Price', value: 'price'},
  ];
  constructor(
    public faService: FontAwesomeService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipment) {
      if (typeof changes.shipment.currentValue !== 'undefined') {
        this.prepare = true;
        this.order = changes.shipment.currentValue.order;
        this.shipment = changes.shipment.currentValue;
        this.shipment.from = changes.shipment.currentValue.consignor;
        this.shipment.to = changes.shipment.currentValue.consignee;
        delete this.shipment.order;
      }
    }
  }

  applyFilter(data) {
  }

  private getDefaultCost(): { amount: number, vat: number } {
    return { amount: 0, vat: 0 };
  }

  private calculateCost(items: any[]): { amount: number, vat: number } {
    if (!items || items.length === 0) {
      return this.getDefaultCost();
    }

    return items.reduce((total, item) => {
      const amount = Number(item.price ? item.price : 0);
      const vat = amount * (Number(item.vat_rate ? item.vat_rate : 0) / 100);

      return {
        amount: total.amount + amount,
        vat: total.vat + vat
      };
    }, this.getDefaultCost());
  }

  get shipmentCost(): { amount: number, vat: number } {
    // const surcharges = this.calculateCost(this.shipment.surcharges);
    // const services = this.calculateCost(this.shipment.additional_services);
    // const vat = this.shipment.vat - (surcharges.vat + services.vat);
    // console.log(surcharges, services);
    return {
      amount: this.shipment ? Math.ceil(+this.shipment.price + +this.shipment.fee + +this.shipment.discount) : 0,
      vat: Number(this.shipment.vat)
    };
  }

  get surchargesCost(): { amount: number, vat: number } {
    return this.calculateCost(this.shipment.surcharges);
  }

  get additionalServicesCost(): { amount: number, vat: number } {
    return this.calculateCost(this.shipment.additional_services);
  }

  get oldAddonsCost(): { amount: number, vat: number } {
    if (!this.shipment || !this.shipment.addons) {
      return this.getDefaultCost();
    }
    return this.shipment.addons.reduce((total, addon) => {
      const amount = Number(addon.price);
      // const vat = amount * (Number(addon.info.vat_rate) / 100);
      return {
        amount: total.amount + amount,
        vat: 0
      };
    }, this.getDefaultCost());
  }

  get oldExtraChargesCost(): { amount: number, vat: number } {
    if (!this.shipment || !this.shipment.extra_charges) {
      return this.getDefaultCost();
    }
    return this.shipment.extra_charges.reduce((total, charge) => {
      const amount = Number(charge.amount);
      const vat = Number(charge.vat);
      return {
        amount: total.amount + amount,
        vat: total.vat + vat
      };
    }, this.getDefaultCost());
  }

  get totalCost(): { amount: number, vat: number } {
    const shipmentCost = this.shipmentCost;
    const surchargesCost = this.surchargesCost;
    const additionalServicesCost = this.additionalServicesCost;
    const oldAddonsCost = this.oldAddonsCost;
    const oldExtraChargesCost = this.oldExtraChargesCost;

    return {
      amount: shipmentCost.amount + surchargesCost.amount + additionalServicesCost.amount + oldAddonsCost.amount + oldExtraChargesCost.amount,
      vat: shipmentCost.vat + surchargesCost.vat + additionalServicesCost.vat + oldAddonsCost.vat + oldExtraChargesCost.vat
    };
  }

  /*
  get price() {
    return this.shipment ? Math.ceil(+this.shipment.price + +this.shipment.fee + +this.shipment.discount) : 0;
  }

  get total() {
    const addon = this.shipment.addons && this.shipment.addons.length ? +this.shipment.addons[0].price : 0;
    return +this.price + +addon + +this.shipment.vat;
  }
  */
}




// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/shipment-title/shipment-title.component.ts